<div class="logo-delcorp">

  <figure class="figure">
    <img class="figure-img img-fluid" src={{logo.url}} [ngStyle]= "{'width': flagCliente ? '280px': '400px'}" >
  </figure>
</div>

<div class="content" *ngIf="codcliente !== 'NXVSENIORTAXI' else LOGINSENIORTAXI">
  <form (ngSubmit)="iniciarSesion()" [formGroup]="loginForm" class="form form-inicioSesion">

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="input-group mb-3">
        <div style="    flex: 1 1 100%;">
          <input type="email" class="form-control" placeholder="Correo" formControlName="txtEmail">

        </div>
        <div class="eye">
          <fa-icon [icon]="['far', 'envelope']"></fa-icon>

        </div>

        <div class="exclamation" *ngIf="f.txtEmail.invalid && (f.txtEmail.dirty || f.txtEmail.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="f.txtEmail.errors.required"></fa-icon>
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Formato de correo incorrecto" placement="top" *ngIf="f.txtEmail.errors.email"></fa-icon>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="input-group mb-3">
        <div style="flex: 1 1 100%;">
          <input class="form-control" type="password" placeholder="Contraseña" formControlName="txtClave">
        </div>
        <div class="eye">
          <fa-icon [icon]="['fas', 'unlock-alt']"></fa-icon>

        </div>
        <div class="exclamation" *ngIf="f.txtClave.invalid && (f.txtClave.dirty || f.txtClave.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="f.txtClave.errors.required"></fa-icon>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12">
      <button type="submit" class="btn  btn-block" [ngClass]=" loginForm.invalid  ? 'btn-secondary' : 'btn-primary'  "
        [disabled]="loginForm.invalid && disabledBtnIngresar">
        INGRESAR
        <fa-icon [icon]="['fas', enviar ? 'circle-notch' : '']" [spin]="enviar ? true : false"></fa-icon>
      </button>
      <button *ngIf="inicioFb" type="button" class="btn btn-facebook text-white btn-block" (click)="loginFB(template)">
        <fa-icon [icon]="['fab', 'facebook-square']" style="font-size: 1rem !important; padding-right: 5px; "></fa-icon>
        <span>
          INICIAR SESIÓN CON FACEBOOK
        </span>
      </button>
    </div>
  </form>


  <div class="row justify-content-md-center" style="margin:0px; margin-top:15px;">

    <div *ngIf="registroUsuario" class="col-lg-6 col-md-6 col-sm-6 col-12">
      <ng-container *ngIf="cod_cliente == 'NXVMOVICAB'; else elseTemplate">
        <a [routerLink]="['verify-email']" class="btn btn-light btn-block  btn-sm">
          {{btnRegistrarse}}
        </a>
      </ng-container>
      <ng-template #elseTemplate>
        <a [routerLink]="['registro']" class="btn btn-light btn-block  btn-sm">
          {{btnRegistrarse}}
        </a>
      </ng-template>



    </div>
    <div *ngIf="olvideContrasenia" class="col-lg-6 col-md-6 col-sm-6 col-12 center-block">
      <button type="button" class="btn btn-light btn-block  btn-sm" (click)="olvidoContrasenia(templateRecuperar)">
        {{btnRecuperarContrasenia}}
      </button>
    </div>
  </div>
</div>






<!--LOGIN SEÑOR TAXI-->
<ng-template #LOGINSENIORTAXI>
  <form (ngSubmit)="iniciarSesion()" [formGroup]="loginFormSeniorTaxi" class="form form-inicioSesion">

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="input-group mb-3" style="text-align: center;">
        <div style="    flex: 1 1 100%;">
          <input type="email" class="campo1" placeholder="Cod. cliente" formControlName="ordenInterno">

        </div>

        <div class="exclamation" *ngIf="f.txtEmail.invalid && (f.txtEmail.dirty || f.txtEmail.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="f.txtEmail.errors.required"></fa-icon>
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Formato de correo incorrecto" placement="top" *ngIf="f.txtEmail.errors.email"></fa-icon>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="input-group mb-3" style="text-align: center;">
        <div style="    flex: 1 1 100%;">
          <input type="email" class="campo1" placeholder="Cod. usuario" formControlName="CodigoTrabajador">

        </div>


        <div class="exclamation" *ngIf="f.txtEmail.invalid && (f.txtEmail.dirty || f.txtEmail.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="f.txtEmail.errors.required"></fa-icon>
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Formato de correo incorrecto" placement="top" *ngIf="f.txtEmail.errors.email"></fa-icon>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="input-group mb-3" style="text-align: center;">
        <div style="flex: 1 1 100%;">
          <input class="campo1" type="password" placeholder="Contraseña" formControlName="txtClaveSeniorTaxi">
        </div>
        <div class="exclamation" *ngIf="f.txtClave.invalid && (f.txtClave.dirty || f.txtClave.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="f.txtClave.errors.required"></fa-icon>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div class="col-lg-12 col-md-12 col-12">
      <div style="flex: 1 1 100%;"style="text-align: center;">
      <button type="submit" class="btn boton-sesion campo" [ngClass]=" loginForm.invalid  ? 'btn-secondary' : 'btn-primary'  "
        [disabled]="loginForm.invalid && disabledBtnIngresar">
        Ingresar

      </button>
      </div>

    </div>
  </form>

</ng-template>


<ng-template #templateRecuperar>
  <form (ngSubmit)="recuperarContrasenia()" [formGroup]="contraseniaForm" class="form-inicioSesion">
    <div class="modal-body text-center">

      <p>
        <strong>Establecer nueva contraseña</strong>
        <br>
        <span>Por favor introduzca su email.</span>
      </p>

      <div class="col-lg-12 col-md-12 col-12 ">
        <div class="input-group mb-3">
          <div style="    flex: 1 1 100%;">
            <input type="email" class="form-control" placeholder="Correo" formControlName="txtCorreoRecuperar">

          </div>
          <div class="eye">
            <fa-icon [icon]="['far', 'envelope']"></fa-icon>

          </div>

          <div class="exclamation" *ngIf="fContrasenia.txtCorreoRecuperar.invalid && (fContrasenia.txtCorreoRecuperar.dirty || fContrasenia.txtCorreoRecuperar.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top" *ngIf="fContrasenia.txtCorreoRecuperar.errors.required"></fa-icon>
            <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Formato de correo incorrecto" placement="top"
              *ngIf="fContrasenia.txtCorreoRecuperar.errors.email"></fa-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" (click)="recuperarContrasenia()" [disabled]="contraseniaForm.invalid || disabledRecuperarContrasenia">Enviar</button>
      <button type="button" class="btn btn-default" (click)=" cerrarModal()">Cancelar</button>
    </div>

  </form>
</ng-template>

<ng-template #template>
  <div class="modal-body text-center">

    <p>
      <strong>Su email no esta registrado. </strong>
      <span>¿Desea registrarse?</span>
    </p>


  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="registrarParticular()">Sí</button>
    <button type="button" class="btn btn-primary" (click)=" decline()">No</button>
  </div>
</ng-template>
